export default "__VITE_ASSET__co0ZXu9K__"